import dayjs from 'dayjs';
import utc from 'dayjs-plugin-utc';
import api from '../../api/index';
dayjs.extend(utc);

// function get_date(date) {
//   return new dayjs(parseInt(date)).utc().format('DD.MM.YYYY');
// }

export default {
  namespaced: true,
  state     : {
    status_changes: [
      {
        text: 'Новый',
        date: 1551179600000,
      },
      {
        text: 'Идет обучение',
        date: 1550179600000,
      },
      {
        text: 'Завершен',
        date: 1551279600000,
      },
    ],
    test_attemps: [
      {
        result: '45/80',
        time  : '01:35:05',
        date  : 1551289600000,
      },
      {
        result: '79/80',
        time  : '01:35:05',
        date  : 1551271600000,
      },
      {
        result: '89/80',
        time  : '01:35:05',
        date  : 1551279000000,
      },
    ],
    user_study_stats: {
      'course_name'         : 'string',
      'user_name'           : 'string',
      'status'              : 'string',
      'required_course'     : 'string',
      'all_lessons'         : 0,
      'passed_lessons'      : 0,
      'course_date_start'   : 'string',
      'course_date_finish'  : 'string',
      'course_series_name'  : 'string',
      'count_questions'     : 0,
      'points_min'          : 0,
      'time_limit'          : 0,
      'test_result'         : 'string',
      'attempts_count'      : 0,
      'points_max'          : 'string',
      'date_finish'         : 'string',
      'expired_days'        : 0,
      'status_new_date'     : 'string',
      'status_current_date' : 'string',
      'status_finished_date': 'string',
      'test_history'        : [
        {
          'number'  : 0,
          'points'  : 0,
          'duration': 'string',
          'date'    : 'string',
        },
      ],
    },
    // course_info_stats: {
    //
    //   chart: {
    //     labels: [1551279600000, 1551371700000, 1551469600000, 1551159600000, 1551019600000, 1551546600000, 1551099600000, 1551679650000, 1551979600000, 1551809600000],
    //     data  : [80, 70, 90, 60, 70, 60, 95, 70, 60, 85],
    //   },
    // },
    course_info_stats: {
      'course_name'                     : 'string',
      'required_course'                 : 'string',
      'course_series_name'              : 'string',
      'all_course_count'                : 0,
      'new_course_count'                : 0,
      'current_course_count'            : 0,
      'completed_course_count'          : 0,
      'not_expired_course_history_count': 0,
      'expired_course_history_count'    : 0,
      'statement_date'                  : 'string',
      'all_lesson_count'                : 0,
      'all_lesson_sales_count'          : 0,
      'question_count'                  : 0,
      'question_sales_count'            : 0,
      'points_min'                      : 0,
      'points_max'                      : 0,
      'test_above'                      : 0,
      'test_below'                      : 0,
      'test_average_points'             : 0,
      'test_history_points'             : [
        {
          'date'  : 'string',
          'points': 0,
        },
      ],
      'chart': {
        labels: [1551279600000, 1551371700000, 1551469600000, 1551159600000, 1551019600000, 1551546600000, 1551099600000, 1551679650000, 1551979600000, 1551809600000],
        data  : [80, 70, 90, 60, 70, 60, 95, 70, 60, 85],
      },
    },

  },
  getters: {
    learning_info    : ({learning_info}) => learning_info,
    status_changes   : ({status_changes}) => status_changes,
    test_attemps     : ({test_attemps}) => test_attemps,
    user_study_stats : ({user_study_stats}) => user_study_stats,
    course_info_stats: ({course_info_stats}) => course_info_stats,
    chart_labels     : ({course_info_stats}) => {
      let labels = course_info_stats.test_history_points.map((item)=>{
        return item.date;
      });
      return labels;
    },
    chart_data: ({course_info_stats}) => {
      let points = course_info_stats.test_history_points.map((item)=>{
        return item.points;
      });
      return points;
    },
    threshold_value: ({course_info_stats}) => {
      let value = Array(course_info_stats.test_history_points.length).fill(course_info_stats.points_min);
      return value;
    },
  },
  mutations: {
    USER_COURSE_DETAIL(state, value) {
      state.user_study_stats = value;
    },
    SET_COURSE_DETAIL(state, value) {
      state.course_info_stats = value;
      if (state.course_info_stats.test_history_points) {
        state.course_info_stats.test_history_points.map((item)=>{
          item.date = new Date(item.date.split('.')[2], item.date.split('.')[0], item.date.split('.')[1]);
          return item;
        });
        state.course_info_stats.test_history_points.sort((a, b)=>a.date-b.date);
        state.course_info_stats.test_history_points.map((item)=>{
          item.date = dayjs(item.date).format('DD.MM.YYYY');
          return item;
        });
      }
    },
  },
  actions: {
    async user_course_detail({commit, rootGetters}) {
      let current_user = rootGetters['employee_study/current_user'];
      let current_course = rootGetters['employee_study/current_course'];
      try {
        const get_detail = await api.learning.user_learning_detail(current_user, current_course);
        commit('USER_COURSE_DETAIL', get_detail.data);
      } catch (err) {
        console.error(err);
      }
    },
    async get_course_detail({commit, rootGetters}, obj) {
      let {period_start, period_finish} = obj;
      let current_course = rootGetters['employee_study/current_course'];
      try {
        const get_detail = await api.learning.course_learning_detail(current_course, period_start, period_finish);
        commit('SET_COURSE_DETAIL', get_detail.data);
      } catch (err) {
        console.error(err);
      }
    },
  },
};
